<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Добавить район</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'city-details', params: { city_id: $route.params.city_id } }">← Назад к Районам</router-link>
    </div>

    <district-add-form :city="+$route.params.city_id" @after="handleAfter" />

  </div>
</template>

<script>
import districtAddForm from '@/components/forms/district/DistrictAddForm'

export default {
  name: 'district-add',
  components: { districtAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'city-details', params: { city_id: this.$route.params.city_id } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// DistrictAdd.vue?f129b462